export default {"src":"/_next/static/media/left-arrow-circle.6d2da74f.svg","height":44,"width":43,"blurWidth":0,"blurHeight":0};